function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { connect as connectFormik } from "formik";
var Button = styled.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.native.button;
});
var FormikButton = connectFormik(function(_param) {
    var formik = _param.formik, disabled = _param.disabled, alwaysActive = _param.alwaysActive, rest = _objectWithoutProperties(_param, [
        "formik",
        "disabled",
        "alwaysActive"
    ]);
    var isDisabled = Boolean(!alwaysActive && (Object.keys(formik.touched).length && formik.submitCount && !formik.isValid || formik.isSubmitting || disabled));
    return /*#__PURE__*/ React.createElement(Button, _extends({
        disabled: isDisabled
    }, rest));
});
export { FormikButton };
export default Button;
